import { styled } from '@mui/material';
import PerfectScrollbar from 'components/SafePerfectScrollbar';

const StyledPerfectScrollbar = styled(PerfectScrollbar)({
  overflowY: 'auto', height: '70rem', marginTop: '1rem', overflowX: 'hidden'
});

export default StyledPerfectScrollbar;